<script>
  import { onDestroy } from "svelte"
  import Shell from "./Shell.svelte"
  import { session, master, update } from "../store"
  import play from "../lib/play"

  let count = 0
  let status = ""
  let starting = false
  let countdown = 10
  let timo = 0

  $: {
    if (status !== $session.onStatus) {
      status = $session.onStatus
      if (status === "starting") {
        starting = true
        timo = setInterval(() => {
          if (countdown > 0) {
            countdown -= 1
            if (countdown < 6) {
              play(countdown === 0 ? "beep1" : "beep")
            }
          }
          if ($master) {
            if (countdown === 0) {
              update("nextPhase", $session.submitTime || 25)
              update("onStatus", "playing")
            }
          }
        }, 950)
      }
    }
    count = Object.values($session.participants).length
  }
  onDestroy(() => {
    clearTimeout(timo)
  })
</script>

<style lang="scss">
  @import "../vars";
  h1 {
    text-align: center;
  }
  div div {
    padding: 3em 0;
    font-size: 1.3rem;
    text-align: center;
    margin: 0 3rem;
    @include below(bigphone) {
      margin: 0;
    }
  }
  .participants {
    background: $green;
    color: $white;
    width: 50%;
    margin: 0 auto 4rem;
    padding: 1.5rem 0 2rem;
    font-family: Produkt;
    transition: all 200ms;
    &.starting {
      background: $blue;
    }
    span {
      font-size: 3.5rem;
      display: block;
    }
    @include below(bigphone) {
      width: 90%;
      margin-bottom: 1.2rem;
    }
  }
  .starting {
    font-size: 1.7rem;
  }
  .startingNow .participants {
    background: $orange;
  }
</style>

<div class:startingNow={starting}>
  <h1>{starting ? 'Here we go!' : 'Hold on tight!'}</h1>
  <Shell>
    {#if starting}
      <div class="starting">Get ready...</div>
      <div class="participants">
        The game starts in
        <span>{countdown}</span>
      </div>
    {:else}
      <div>The game will start soon, start warming up your fingers.</div>
      <div class="participants">
        <span>{count}</span>
        WDSers waiting to play
      </div>
    {/if}
  </Shell>
</div>
